module.exports = __webpack_public_path__ + "img/pie-chart-white.d2454082.svg";